import { DealerID } from "./Dealer";
import { DealerLocationID } from "./DealerLocation";
import { LANGUAGE_CODES } from "./Language";
import { User, UserID } from "./User";

export type ArticleID = number;

export type CategoryID = number;

export interface Article {
  created_on: string;
  updated_on: string;
  id: ArticleID;
  title: string;
  content: string;
  selector: string;
  language_code: LANGUAGE_CODES;
  category_id: CategoryID | null;
  publish_date: string | null;
  expire_date: string | null;
  visible_to_all: boolean;
  visible_on_tablet: boolean;
  user_id: UserID;
  updated_by_id: UserID | null;
  disabled: boolean;
  stripe_opened_count: number;
  stripe_closed_count: number;
  user?: User;
  location_ids?: DealerLocationID[];
  dealer_ids?: DealerID[];
  updated_by?: User;
}

export interface ArticleLocation {
  article_id: ArticleID;
  location_id: DealerLocationID;
}

export interface ArticleDealer {
  article_id: ArticleID;
  dealer_id: DealerID;
}

export interface ArticleCategory {
  created_on: string;
  updated_on: string;
  id: CategoryID;
  name: string;
}
